// Iter-46an: format a studio's address parts (address, city, county,
// eircode/postal_code) into a single human-readable string. Used by the
// public studio detail page (header subtitle + Info tab + map subtitle)
// so the full address is always shown, never just line 1.

/**
 * @param {object} studio Studio object with optional address/city/county/eircode/country fields
 * @param {object} [opts]
 * @param {string} [opts.separator] Joiner between parts. Defaults to ", ".
 * @returns {string} Joined, trimmed address. Empty string if no parts.
 */
export function formatStudioAddress(studio, opts = {}) {
  if (!studio) return '';
  const parts = [
    studio.address,
    studio.city,
    studio.county || studio.state,
    studio.eircode || studio.postal_code || studio.zip,
    studio.country,
  ]
    .map((p) => (typeof p === 'string' ? p.trim() : ''))
    .filter(Boolean);
  const seen = new Set();
  const deduped = parts.filter((p) => {
    const key = p.toLowerCase();
    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  });
  return deduped.join(opts.separator || ', ');
}

/** Returns a Google Maps directions URL for the studio address. */
export function googleMapsDirectionsUrl(studio) {
  const q = encodeURIComponent(formatStudioAddress(studio));
  return q ? `https://www.google.com/maps/dir/?api=1&destination=${q}` : '';
}

/** OpenStreetMap embed URL — used in an iframe; no API key required. */
export function openStreetMapEmbedUrl(studio) {
  const q = encodeURIComponent(formatStudioAddress(studio));
  return q
    ? `https://www.openstreetmap.org/export/embed.html?bbox=&layer=mapnik&search=${q}`
    : '';
}
